import { tolgee } from "@/providers/TranslationProvider";

export const getWorklistTasksText = (task: string): string => {
  switch (task) {
    case "DELIVERY_NEEDED":
      return tolgee.t("worklist.tasks.DELIVERY_NEEDED");
    case "DESIGN_NEEDED":
      return tolgee.t("worklist.tasks.DESIGN_NEEDED");
    case "MODIFICATION_REQUEST_APPROVAL_NEEDED":
      return tolgee.t("worklist.tasks.MODIFICATION_REQUEST_APPROVAL_NEEDED");
    case "PRE_MEDIA_PROPOSITION_NEEDED":
      return tolgee.t("worklist.tasks.PRE_MEDIA_PROPOSITION_NEEDED");
    case "PRE_MEDIA_PROPOSITION_VALIDATION_NEEDED":
      return tolgee.t("worklist.tasks.PRE_MEDIA_PROPOSITION_VALIDATION_NEEDED");
    case "PRE_MEDIA_REQUEST_COMPLETION_NEEDED":
      return tolgee.t("worklist.tasks.PRE_MEDIA_REQUEST_COMPLETION_NEEDED");
    case "PRE_MEDIA_REQUEST_SUBMISSION_NEEDED":
      return tolgee.t("worklist.tasks.PRE_MEDIA_REQUEST_SUBMISSION_NEEDED");
    case "PRE_MEDIA_REQUEST_VALIDATION_NEEDED":
      return tolgee.t("worklist.tasks.PRE_MEDIA_REQUEST_VALIDATION_NEEDED");
    case "PROOF_AVAILABLE":
      return tolgee.t("worklist.tasks.PROOF_AVAILABLE");
    case "PROOF_NEEDED":
      return tolgee.t("worklist.tasks.PROOF_NEEDED");
    case "PURCHASE_ORDER_NEEDED":
      return tolgee.t("worklist.tasks.PURCHASE_ORDER_NEEDED");
    case "QUOTE_AVAILABLE":
      return tolgee.t("worklist.tasks.QUOTE_AVAILABLE");
    case "QUOTE_NEEDED":
      return tolgee.t("worklist.tasks.QUOTE_NEEDED");
    case "RETROPLANNING_SHARED":
      return tolgee.t("worklist.tasks.RETROPLANNING_SHARED");
    case "RETROPLANNING_TO_FILL":
      return tolgee.t("worklist.tasks.RETROPLANNING_TO_FILL");
    case "VALIDATION_NEEDED":
      return tolgee.t("worklist.tasks.VALIDATION_NEEDED");
    case "DELIVERY_LABEL_NEEDED":
      return tolgee.t("worklist.tasks.DELIVERY_LABEL_NEEDED");
    default:
      return task;
  }
};
